export type QueueSnapshot = {
  nowServing: number | null
  waiting: number[]
  maxIssued: number | null
  date: string
}

export type MyQueueStatus =
  | { state: 'waiting'; ahead: number }
  | { state: 'ready' }
  | { state: 'unknown' }

/**
 * แปลง snapshot รวม → สถานะของคิวหมายเลขเดียว
 *
 * 'ready' ตัดสินจาก maxIssued ไม่ใช่ nowServing เพราะบาริสต้าอาจกด Complete
 * ไม่เรียงลำดับ — เลขที่หลุดจาก waiting แปลว่าจบแล้ว ไม่ว่าจะเสร็จก่อนหรือหลังเลขอื่น
 *
 * เคสขอบที่ยอมรับ (ระบุไว้ใน spec): บิลที่ถูกยกเลิกจะเข้าเงื่อนไข 'ready'
 * เพราะหลุดจาก waiting แต่ยังต่ำกว่า maxIssued — ลูกค้าจะไปถามที่เคาน์เตอร์ซึ่งรู้อยู่แล้ว
 */
export const deriveMyQueueStatus = (
  queueNumber: number,
  snapshot: QueueSnapshot
): MyQueueStatus => {
  const { waiting, maxIssued } = snapshot

  // queueNumber มาจาก URL path param (`/q/:queueNumber` ผ่าน Number(...)) — เชื่อไม่ได้
  // Number('abc') = NaN (ตกด่านต่อไปอยู่แล้วเพราะ NaN <= n เป็น false ทุกกรณี)
  // แต่ Number('0') / Number('-1') / Number('25.5') ล้วนเป็นตัวเลขจริงที่ผ่าน <= maxIssued ได้
  // ต้องกันตรงนี้ ไม่ใช่พึ่งพา caller — ฟังก์ชันนี้ต้องถูกไม่ว่าใครเรียก
  if (!Number.isInteger(queueNumber) || queueNumber < 1) return { state: 'unknown' }

  if (waiting.includes(queueNumber)) {
    return { state: 'waiting', ahead: waiting.filter((n) => n < queueNumber).length }
  }

  if (maxIssued !== null && queueNumber <= maxIssued) return { state: 'ready' }

  return { state: 'unknown' }
}
